import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StampStatisticsService } from '../../../evs/statistics/StampStatistics.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BatchService } from '../../batchstamp/batch.service';
import { Router } from '@angular/router';
import { ModalCancelStampComponent } from '../../popup/modalCancelStamp.component';
import { Subscription } from 'rxjs/Rx';
import { EvsProductService } from '../../../../../common/services/EvsProduct.service';
import { IOption } from 'ng-select';
import { EvsStoreService } from '../../../../../common/services/EvsStore.service';
import { ImageService } from '../../../../imageService';
import { environment } from 'environments/environment';
import { WarningOutdateService } from 'app/common/services/WarningOutdate.service';
import { ActivatedRoute, Params } from '@angular/router';
import { saveAs } from 'file-saver/FileSaver';
import { TranslateService } from '@ngx-translate/core';

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;
declare var Chartist: any;
let that;

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.css'],
  providers: [
    StampStatisticsService,
    EvsAddressService,
    EvsProductService,
    EvsStoreService,
    ImageService,
    WarningOutdateService,
  ],
})
export class WarningComponent implements OnInit, OnDestroy {
  @ViewChild('popDistrict') pop: any;
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  warnings: any = [];
  warningsUseTime: any = [];
  scanStatusLocation: any = [];
  warningFilter: any = {};
  cities: any = [];
  districts: any = [];
  stores: any = [];
  locationScan: any = [];
  serialLocation: any = null;

  warningPage_Size: any = 8;
  warningCurrentPage: any = 1;
  totalWarningPage: any = 0;
  totalWarningPageUseTime: any = 0;
  totalWarningPageRepeatTime: any = 0;
  currentPageUseTime: any = 1;
  currentPageRepeatTime: any = 1;
  modalRef: BsModalRef;
  modalRefLocation: BsModalRef;
  listBatchs: Array<IOption> = [];
  listProducts: Array<IOption> = [];
  zoom: number = 15;

  types: any = [
    {
      value: 1,
      label: 'Vượt quá số lần quét',
      key: 'VUOT_QUA_SO_LAN_QUET'
    },
    // {
    //   value: 2,
    //   label: "Tràn hàng",
    //   key: 'TRAN_HANG'
    // },
    {
      value: 3,
      label: 'Cảnh báo doanh nghiệp',
      key: 'CANH_BAO_DOANH_NGHIEP'
    },
  ];

  subcribe: Subscription = null;
  isChongia: boolean = true;

  // storeWarnings: any = [];
  cityWarnings: any = [];
  districtWarnings: any = [];
  dataPieCity1: any = {};

  // storeWarnings2: any = [];
  cityWarnings2: any = [];
  districtWarnings2: any = [];
  dataPieCity2: any = {};

  colors: any = [
    {
      id: 1,
      color: '#061178',
    },
    {
      id: 2,
      color: '#926dde',
    },
    {
      id: 3,
      color: '#7dd3ae',
    },
    {
      id: 4,
      color: '#9bee48',
    },
    {
      id: 5,
      color: '#70726d',
    },
    {
      id: 6,
      color: '#df0f57',
    },
    {
      id: 7,
      color: '#317187',
    },
    {
      id: 8,
      color: '#d7cbb6',
    },
  ];
  listClass: any = [
    'ct-series-a',
    'ct-series-b',
    'ct-series-c',
    'ct-series-d',
    'ct-series-e',
    'ct-series-f',
    'ct-series-g',
    'ct-series-h',
    'ct-series-i',
  ];

  batchs: any = [];
  list_stores: any = [];
  provinces: any = [];
  province_data_page: any = [];

  batchPage_Size: any = 4;
  batchCurrentPage: any = 1;
  totalBatchPage: any = 0;

  storePage_Size: any = 6;
  storeCurrentPage: any = 1;
  totalStorePage: any = 0;

  provincePage_Size: any = 6;
  provinceCurrentPage: any = 1;
  totalProvincePage: any = 0;
  showMoreFilter: boolean = true;
  listDayAgo: any = [1, 2, 3, 4, 5, 6, 7];
  listAlertRepeatTime: any = [];

  activeTab: any = 1;

  constructor(
    private statisticService: StampStatisticsService,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private modalService: BsModalService,
    private batchService: BatchService,
    private productService: EvsProductService,
    private storeService: EvsStoreService,
    private router: Router,
    private imageService: ImageService,
    private warningOutdateService: WarningOutdateService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {
    that = this;
    this.subcribe = this.modalService.onHide.subscribe(() => {
      this.locationScan = [];
      this.serialLocation = null;
    });

    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  updateTranslations() {
    this.types.forEach(type => {
      if (type.key) {
        type.label = this.translate.instant(type.key);
      }
    });

    $('#day-ago').select2({ placeholder: this.translate.instant('SO_NGAY_TRUOC'), width: '100%', allowClear: true });
    $('#product').select2({ placeholder: this.translate.instant('SAN_PHAM'), allowClear: true });
    $('#batch_id').select2({ placeholder: this.translate.instant('LO_TEM'), allowClear: true });
    $('#product1').select2({ placeholder: this.translate.instant('SAN_PHAM'), allowClear: true });
    $('#batch_id1').select2({ placeholder: this.translate.instant('LO_TEM'), allowClear: true });
    $('#type').select2({ placeholder: this.translate.instant('LOAI_CANH_BAO'), allowClear: true });
    $('#outdate-product').select2({ placeholder: this.translate.instant('SAN_PHAM'), allowClear: true });
    $('#outdate-batch_id').select2({ placeholder: this.translate.instant('LO_TEM'), allowClear: true });
    $('#store').select2({ placeholder: this.translate.instant('CUA_HANG'), allowClear: true });
    $('#city').select2({ placeholder: this.translate.instant('TINH_THANH_PHO'), allowClear: true });
    $('#district').select2({ placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: true });
  }

  sortScanCount(e: string) {
    if (e === this.warningFilter.sort_scan_count) {
      this.warningFilter.sort_scan_count = ''
    } else {
      this.warningFilter.sort_scan_count = e
    }
    this.filterWarning()
  }

  sortPeopleCount(e: string) {

    if (e === this.warningFilter.sort_people_count) {
      this.warningFilter.sort_people_count = ''
    } else {
      this.warningFilter.sort_people_count = e
    }
    this.filterWarning()
  }

  isDashboard = false;

  ngOnInit() {
    this.isDashboard = this.router.url.includes('/evs/dashboard');

    // ata.from = moment(this.warningFilter.time[0]).format('YYYY-MM-DD');
    // data.to = moment(this.warningFilter.time[1]).format('YYYY-MM-DD');

    this.updateTranslations();

    $('#store').select2({
      placeholder: this.translate.instant('CUA_HANG'),
      allowClear: true,
      ajax: {
        url: environment.api_evs + '/g_store?limit=50',
        headers: {
          authorization: localStorage.getItem('Access-Token'),
        },
        dataType: 'json',
        data: function (params) {
          var query: any = {
            desc: 'created_at',
          };
          if (params.term) {
            query.name = params.term;
          }
          return query;
        },
        processResults: function (data) {
          // Tranforms the top-level key of the response object from 'items' to 'results'
          let stores = data.data.store;
          let listStores: any = [];
          for (let i = 0; i < stores.length; i++) {
            let item = {
              id: stores[i].id.toString(),
              text: stores[i].name,
            };
            listStores.push(item);
          }
          this.stores = listStores;
          return {
            results: this.stores,
          };
        },
      },
    });
    let city_ele = $('#city');
    city_ele.on('select2:select', function (e) {
      that.warningFilter.city = e.params.data.id;
      that.getDistrict();
    });
    city_ele.on('select2:unselect', function () {
      that.districts = [];
      $('#district').val(null).trigger('change');
    });


    this.getStores();
    this.getBatch();
    this.getStore();
    this.getProvince();
    this.getCity();
    this.getListProduct();
    this.getListBatches();
    this.getWarning();
    this.getOverflow();
    // this.getListOutDate();

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (this.isDashboard) {
        this.activeTab = 1;
      } else {
        this.activeTab = params.tab ? parseInt(params.tab, 10) : 2;
        if (this.activeTab === 2) {
          this.isChongia = true;
        } else {
          this.isChongia = false;
        }
        this.selectTab();
      }
    });
  }

  // ngAfterViewInit() {
  //   const start = moment().subtract(2, 'months').startOf('month').toDate();
  //   const end = moment().endOf('month').toDate();
  //   this.warningFilter.time = [start, end];
  // }
  // get list warning outdate time
  // getListOutDate() {
  //   this.warningOutdateService
  //     .getListWarningOutdate()
  //     .toPromise()
  //     .then((res) => {
  //       if (!res.error) {
  //         this.listOutDate = res.data.list;
  //         this.countOutDate = res.data.count;
  //       }
  //     });
  // }

  getBatch() {
    let data: any = {};
    data.offset =
      this.batchPage_Size *
      (this.batchCurrentPage <= 0 ? 0 : this.batchCurrentPage - 1);
    data.limit = this.batchPage_Size;
    data.sort_by = 'id:asc';
    this.statisticService.getDashboardBatchs(data).subscribe((res) => {
      if (!res.error) {
        //console.log(res.data.batches)
        this.batchs = res.data.batch_reports;
        for (let i = 0; i < this.batchs.length; i++) {
          this.batchs[i].image = this.imageService.readSrcImage(
            this.batchs[i].image,
            'thumb_medium'
          );
        }
        let item = res.data.total;
        let pageString = (item / this.batchPage_Size).toString();
        let pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalBatchPage = totalpage;
      }
    });
  }

  setBatchPage(page: number) {
    if (page <= this.totalBatchPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalBatchPage) {
        page = this.totalBatchPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.batchCurrentPage) {
        this.batchCurrentPage = page;
        this.getBatch();
      }
    } else {
      page = this.totalBatchPage;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_TINH_TRANG_LO_TEM'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputOrders').val(1);
        this.batchCurrentPage = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_TINH_TRANG_LO_TEM_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalBatchPage) {
          page = this.totalBatchPage;
        }
        $('#inputOrders').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.batchCurrentPage) {
          this.batchCurrentPage = page;
          this.getBatch();
        }
      }
    }
  }

  goOrdersPage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setBatchPage(toPage);
    }
  }

  setStorePage(page: number) {
    if (page <= this.totalStorePage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalStorePage) {
        page = this.totalStorePage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.storeCurrentPage) {
        this.storeCurrentPage = page;
        this.getStore();
      }
    } else {
      page = this.totalStorePage;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_TINH_TRANG_CUA_HANG'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputStore').val(1);
        this.storeCurrentPage = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_TINH_TRANG_CUA_HANG_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalStorePage) {
          page = this.totalStorePage;
        }
        $('#inputStore').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.storeCurrentPage) {
          this.storeCurrentPage = page;
          this.getStore();
        }
      }
    }
  }

  goStorePage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setStorePage(toPage);
    }
  }

  getStore() {
    let data: any = {};
    data.page_size = this.storePage_Size;
    data.page = this.storeCurrentPage;

    this.statisticService.getDashBoardStores(data).subscribe((res) => {
      if (res.code === 1) {
        this.list_stores = res.data.items;
        let item = res.data.totalElement;
        this.totalStorePage = Math.ceil(item / this.storePage_Size);
      }
    });
  }

  setProvincePage(page: number) {
    if (page <= this.totalProvincePage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalProvincePage) {
        page = this.totalProvincePage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.provinceCurrentPage) {
        this.provinceCurrentPage = page;
        this.getPageProvince(this.provinceCurrentPage);
      }
    } else {
      page = this.totalProvincePage;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_TINH_TRANG_CUA_HANG'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputProvince').val(1);
        this.provinceCurrentPage = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_TINH_TRANG_CUA_HANG_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalProvincePage) {
          page = this.totalProvincePage;
        }
        $('#inputProvince').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.storeCurrentPage) {
          this.provinceCurrentPage = page;
          this.getPageProvince(this.provinceCurrentPage);
        }
      }
    }
  }

  goProvincePage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setProvincePage(toPage);
    }
  }

  getOverflow() {
    let data: any = {};
    this.overflowPageIndex = 0;
    this.statisticService.getDashBoardOverflow(data).subscribe((res) => {
      if (res.code === 1) {
        this.totalOverflow = res.data.items;
        // move tỉnh thành = null to last array
        this.totalOverflow.forEach((gg, index) => {
          if (
            gg.provinceName == 'null' ||
            gg.provinceName == 'undefined' ||
            !gg.provinceName
          ) {
            this.totalOverflow.push(this.totalOverflow.splice(index, 1)[0]);
          }
        });
        for (let i = this.overflowPageIndex; i < this.overflowPageSize; i++) {
          if (this.totalOverflow[i]) {
            this.listOverflow.push(this.totalOverflow[i]);
          }
        }

        this.overflowTotalPage = Math.ceil(
          res.data.totalElement / this.overflowPageSize
        );
        this.pieOverflow(this.listOverflow);
      }
    });
  }

  pieOverflow(listOverflow) {
    let cityHits2 = [];
    this.cityWarnings2 = [];
    let k = 0;
    console.log(listOverflow);

    for (let i = 0; i < listOverflow.length; i++) {
      if (
        listOverflow[i] &&
        listOverflow[i].overflow > 0 &&
        this.cityWarnings2.length < 6
      ) {
        this.cityWarnings2.push({
          city: listOverflow[i].provinceName,
          hits: listOverflow[i].overflow,
          color: this.colors[k].color,
        });
        cityHits2.push(listOverflow[i].overflow);
        k++;
      }
    }

    console.log(' this.cityWarnings2', this.cityWarnings2);
    let options = {
      labelInterpolationFnc: function (value) {
        if (value) {
          return value[0];
        }
      },
    };
    this.dataPieCity2 = {
      series: cityHits2,
    };

    setTimeout(() => {
      if ($('#cityWarnings2')[0]) {
        new Chartist.Pie('#cityWarnings2', this.dataPieCity2, options);
      }
      $(document).on(
        'click',
        '#cityWarnings2 .ct-chart-pie .ct-series',
        function (evt) {
          //$('#cityWarnings .ct-chart-pie .ct-series').on('click', function (evt) {
          that.districtWarnings2 = [];
          let childrens = evt.target.farthestViewportElement.children;
          let listChild = [];
          for (let i = 0; i < childrens.length - 1; i++) {
            listChild.push({
              nodeValue: childrens[i].firstChild.attributes.d.nodeValue,
              value: childrens[i].firstChild.attributes['ct:value'].value,
            });
          }
          let currentChild = {
            nodeValue: evt.target.attributes.d.nodeValue,
            value: evt.target.attributes['ct:value'].value,
          };
          let indexChild = listChild.findIndex(
            (ele) =>
              ele.nodeValue == currentChild.nodeValue &&
              ele.value == currentChild.value
          );
          let city = that.cities.find(
            (ele) => ele.label == that.cityWarnings2[indexChild].city
          );
          if (city) {
            that.getDataDistrictChonggia(2, city.id);
          }
        }
      );
    }, 300);
  }

  getProvince() {
    let data: any = {};
    data.offset =
      this.provincePage_Size *
      (this.provinceCurrentPage <= 0 ? 0 : this.provinceCurrentPage - 1);
    data.limit = this.provincePage_Size;
    data.sort_by = 'id:asc';
    this.statisticService.getDashBoardCity(data).subscribe((res) => {
      if (!res.error) {
        this.provinces = res.data;
        // chuyển các city không xác định đến cuối ds
        this.provinces.forEach((gg, index) => {
          if (gg.city == 'null' || gg.city == 'undefined' || !gg.city) {
            this.provinces.push(this.provinces.splice(index, 1)[0]);
          }
        });
        let item = res.data.length;
        let pageString = (item / this.provincePage_Size).toString();
        let pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalProvincePage = totalpage;
        ///////////////////////////////////////////
        let cityHits1 = [];
        // let cityHits2 = [];
        let h = 0;
        // let k = 0;

        console.log(' this.provinces', this.provinces);
        for (let i = 0; i < this.provinces.length; i++) {
          if (this.provinces[i].verify > 0 && this.cityWarnings.length < 6) {
            this.cityWarnings.push({
              city: this.provinces[i].city,
              hits: this.provinces[i].verify,
              color: this.colors[h].color,
            });
            cityHits1.push(this.provinces[i].verify);
            h++;
          }
        }
        console.log('cityHits1', cityHits1);

        // for (let i = 0; i < this.listOverflow.length; i++) {
        //   console.log(this.listOverflow[i].overflow)
        //   if (this.listOverflow[i].overflow > 0 && this.cityWarnings2.length < 6) {
        //     this.cityWarnings2.push({
        //       city: this.listOverflow[i].provinceName,
        //       hits: this.listOverflow[i].overflow,
        //       color: this.colors[k].color,
        //     });
        //     cityHits2.push(this.listOverflow[i].overflow);
        //     k++;
        //   }
        //
        // }
        //
        // console.log('cityHits2', this.listOverflow)
        let options = {
          labelInterpolationFnc: function (value) {
            if (value) {
              return value[0];
            }
          },
        };
        this.dataPieCity1 = {
          series: cityHits1,
        };
        // this.dataPieCity2 = {
        //   series: cityHits2,
        // };
        setTimeout(() => {
          if ($('#cityWarnings')[0]) {
            new Chartist.Pie('#cityWarnings', this.dataPieCity1, options);
          }
          $(document).on(
            'click',
            '#cityWarnings .ct-chart-pie .ct-series',
            function (evt) {
              //$('#cityWarnings .ct-chart-pie .ct-series').on('click', function (evt) {
              that.districtWarnings = [];
              let childrens = evt.target.farthestViewportElement.children;
              let listChild = [];
              for (let i = 0; i < childrens.length - 1; i++) {
                listChild.push({
                  nodeValue: childrens[i].firstChild.attributes.d.nodeValue,
                  value: childrens[i].firstChild.attributes['ct:value'].value,
                });
              }
              let currentChild = {
                nodeValue: evt.target.attributes.d.nodeValue,
                value: evt.target.attributes['ct:value'].value,
              };
              let indexChild = listChild.findIndex(
                (ele) =>
                  ele.nodeValue == currentChild.nodeValue &&
                  ele.value == currentChild.value
              );
              let city = that.cities.find(
                (ele) => ele.label == that.cityWarnings[indexChild].city
              );
              if (city) {
                that.getDataDistrictChonggia(1, city.id);
              }
            }
          );
        }, 300);
      }
      this.getPageProvince(this.provinceCurrentPage);
    });
  }

  getPageProvince(page: number) {
    let last_index = page * this.provincePage_Size - 1;
    let list_data = [];
    for (
      let i = last_index - (this.provincePage_Size - 1);
      i <= last_index;
      i++
    ) {
      if (this.provinces[i]) {
        list_data.push(this.provinces[i]);
      }
    }
    this.province_data_page = list_data;

    console.log(333, this.province_data_page);
  }

  overflowPageIndex: number = 0;
  overflowPageSize: number = 6;
  overflowCurrentPage: number = 1;
  overflowTotalPage: number = 0;
  listOverflow: any = [];
  totalOverflow: any = [];

  // getOverflowPage(page: number) {
  //   let last_index = page * this.provincePage_Size - 1;
  //   let list_data = [];
  //   for (
  //     let i = last_index - (this.provincePage_Size - 1);
  //     i <= last_index;
  //     i++
  //   ) {
  //     if (this.provinces[i]) {
  //       list_data.push(this.provinces[i]);
  //     }
  //   }
  //   this.province_data_page = list_data;
  //
  //   console.log(333, this.province_data_page)
  // }
  setOverflowPage(page: number) {
    console.log(this.totalOverflow);
    let cityHits2 = [];

    this.listOverflow = [];
    if (page <= this.overflowTotalPage) {
      if (page < 1) {
        page = 1;
      }
      this.overflowCurrentPage = page;
      let lastIndex = page * this.overflowPageSize - 1;
      for (
        let i = lastIndex - (this.overflowPageSize - 1);
        i <= lastIndex;
        i++
      ) {
        if (this.totalOverflow[i]) {
          this.listOverflow.push(this.totalOverflow[i]);
        }
      }
    } else {
      page = this.overflowTotalPage;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_TINH_TRANG_CUA_HANG'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputOverflow').val(1);
        this.overflowCurrentPage = 1;
      } else {
        this.toastr.warning(this.translate.instant('SO_TRANG_TOI_DA_HIEN_TAI_LA') + ' ' + page, '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        if (page < 1) {
          page = 1;
        } else if (page > this.overflowTotalPage) {
          page = this.overflowTotalPage;
        }
        $('#inputOverflow').val(page);
        this.overflowCurrentPage = page;
        let lastIndex = page * this.overflowPageSize - 1;
        for (
          let i = lastIndex - (this.overflowPageSize - 1);
          i <= lastIndex;
          i++
        ) {
          if (this.totalOverflow[i]) {
            this.listOverflow.push(this.totalOverflow[i]);
          }
        }
      }
    }
    this.pieOverflow(this.listOverflow);
  }

  goOverflowPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setOverflowPage(toPage);
    }
  }

  getDataDistrictChonggia(type, id) {
    let districtPie = $('#districtWarnings');
    let districtPie2 = $('#districtWarnings2');
    if (type == 1) {
      if (districtPie[0]) {
        let opt = {
          type: type,
          city: id,
        };
        that.statisticService
          .getDashboardWarningStasitic(opt)
          .subscribe((res) => {
            if (!res.error) {
              this.districtWarnings = res.data.district;
              let districtHits = [];
              for (let i = 0; i < this.districtWarnings.length; i++) {
                districtHits.push(this.districtWarnings[i].hits);
                this.districtWarnings[i]['color'] = this.colors[i].color;
              }
              let options = {
                labelInterpolationFnc: function (value) {
                  if (value) {
                    return value[0];
                  }
                },
              };
              let dataPieDistrict = {
                series: districtHits,
              };
              new Chartist.Pie('#districtWarnings', dataPieDistrict, options);
            }
          });
      }
    } else if (type == 2) {
      if (districtPie2[0]) {
        let opt = {
          type: type,
          city: id,
        };
        that.statisticService
          .getDashboardWarningStasitic(opt)
          .subscribe((res) => {
            if (!res.error) {
              this.districtWarnings2 = res.data.district;
              let districtHits = [];
              for (let i = 0; i < this.districtWarnings2.length; i++) {
                districtHits.push(this.districtWarnings2[i].hits);
                this.districtWarnings2[i]['color'] = this.colors[i].color;
              }
              let options = {
                labelInterpolationFnc: function (value) {
                  if (value) {
                    return value[0];
                  }
                },
              };
              let dataPieDistrict = {
                series: districtHits,
              };
              new Chartist.Pie('#districtWarnings2', dataPieDistrict, options);
            }
          });
      }
    }
  }

  ngOnDestroy() {
    if (this.subcribe) {
      this.subcribe.unsubscribe();
    }
  }

  getStores() {
    let request = {
      limit: 500,
    };
    this.storeService.getAll(request).subscribe((res) => {
      if (!res.error) {
        let stores = [];
        res.data.store.forEach((element) => {
          stores.push({
            value: element.id,
            label: element.name,
            id: element.id,
          });
        });
        this.stores = stores;
      }
    });
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.id,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  getDistrict() {
    if (this.warningFilter.city) {
      let data: any = {
        city_id: this.warningFilter.city,
      };
      this.addressService.getDistrict(data).subscribe((res) => {
        let districtList = [];
        res.data.districts.forEach((c: any) => {
          districtList.push({
            value: c.id,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districtList;
      });
    }
  }

  getListProduct() {
    let opt: any = {
      limit: 500,
    };
    this.productService.getAllProduct(opt).subscribe((res) => {
      if (!res.error) {
        let products = res.data.products;
        let listProducts: any = [];
        for (let i = 0; i < products.length; i++) {
          let item = {
            value: products[i].id.toString(),
            label: products[i].name,
          };
          listProducts.push(item);
        }
        this.listProducts = listProducts;
      }
    });
  }

  getListBatches() {
    let opt: any = {
      limit: 500,
    };
    this.batchService.getBatchesList(opt).subscribe((res) => {
      if (!res.error) {
        let batchs = res.data.batches;
        let listBatchs: any = [];
        for (let i = 0; i < batchs.length; i++) {
          let item = {
            value: batchs[i].id.toString(),
            label: batchs[i].name,
          };
          listBatchs.push(item);
        }
        this.listBatchs = listBatchs;
      }
    });
  }
  // Hàm chuyển object thành query string
  toQueryString(obj) {
    var str = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
        str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      }
    }
    return str.join('&');
  }
  public messageExport = '';
  exportReport() {
    const [start, end] = this.warningFilter.time;
    const maxRange = moment(start).add(3, 'months');

    if (moment(end).isAfter(maxRange)) {
      // Hiển thị cảnh báo hoặc reset lại
      this.messageExport = this.translate.instant('CHI_DUOC_CHON_TOI_DA_TRONG_VONG_THANG');
      $('.stampBoxStampAlertAdd2').css('display', 'block');
      setTimeout(() => {
        $('.stampBoxStampAlertAdd2').css('display', 'none');
      }, 5000);

      return;
    }


    let data: any = {};
    data.offset =
      this.warningPage_Size *
      (this.warningCurrentPage <= 0 ? 0 : this.warningCurrentPage - 1);
    data.limit = this.warningPage_Size;
    data.sort_by = 'ins_dt:desc';

    if (this.isChongia) {
      data.type = 4;
    } else {
      data.type = 2;
    }
    if (this.warningFilter.serial) {
      data.serial = this.warningFilter.serial.trim();
    }
    // let product_value = $("#product").val();
    let product_value2 = this.productId2 ? this.productId2 : null;
    let product_value3 = this.productId3 ? this.productId3 : null;
    if (product_value2) {
      data.product_id = product_value2;
    }
    if (product_value3) {
      data.product_id = product_value3;
    }
    let batch_id_value = $('#batch_id').val();
    if (batch_id_value) {
      data.batch_id = batch_id_value;
    }
    // let product1_value = $("#product1").val();
    // if (product1_value) {
    //   data.product_id = product1_value;
    // }
    let batch_id1_value = $('#batch_id1').val();
    if (batch_id1_value) {
      data.batch_id = batch_id1_value;
    }
    let type_value = $('#type').val();
    if (type_value) {
      data.type = type_value;
    }
    let store_value = $('#store').val();
    if (store_value) {
      data.store_id = store_value;
    }
    let city_value = $('#city').val();
    if (city_value) {
      data.city = city_value;
    }
    let district_value = $('#district').val();
    if (district_value) {
      data.district = district_value;
    }
    if (this.warningFilter.time) {
      if (this.warningFilter.time.length > 0) {
        data.from = moment(this.warningFilter.time[0]).format('YYYY-MM-DD');
        data.to = moment(this.warningFilter.time[1]).format('YYYY-MM-DD');
      }
    }

    if (this.warningFilter.from) {
      data.active_from = moment(this.warningFilter.from[0]).format(
        'YYYY-MM-DD'
      );
      data.active_to = moment(this.warningFilter.from[1]).format('YYYY-MM-DD');
    }
    if (this.warningFilter.to) {
      data.dead_time_from = moment(this.warningFilter.to[0]).format(
        'YYYY-MM-DD'
      );
      data.dead_time_to = moment(this.warningFilter.to[1]).format('YYYY-MM-DD');
    }
    data.sort_scan_count = this.warningFilter.sort_scan_count
    data.sort_people_count = this.warningFilter.sort_people_count
    var queryString = this.toQueryString(data);
    var url = environment.api_evs + '/dashboard/warning/excel?' + queryString;
    this.batchService.downloadExcelExample2(url).subscribe((res) => {
      saveAs(res, `Baocao.xlsx`)
    }, error => {
      this.toastr.warning(error.message, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    })

    // this.exportService.exportInventoryBatchExport(data).subscribe((res) => {
    //   if (res.code == 1) {
    //     this.messageExport = 'Hệ thống đang xử lý xuất file, vui lòng chờ trong giây lát và nhận kết quả trong mục thông báo.';
    //     $('.stampBoxStampAlertAdd').css('opacity', '1');
    //     setTimeout(() => {
    //       $('.stampBoxStampAlertAdd').css('opacity', '0');
    //     }, 5000);
    //   } else {
    //     this.toastr.error(res.message, 'Thông báo', {
    //       timeOut: 4000,
    //       positionClass: 'toast-bottom-right'
    //     })
    //   }
    // }, (error) => {
    //   console.log('123123', 123123)
    //   this.toastr.error(error.message, 'Thông báo', {
    //     timeOut: 4000,
    //     positionClass: 'toast-bottom-right'
    //   })
    // });
  }

  selectTab() {
    if (this.activeTab === 2) {
      setTimeout(() => {
        const startDate = moment().subtract(2, 'months').startOf('month').toDate();
        const endDate = moment().endOf('month').toDate();
        this.warningFilter.time = [startDate, endDate];

        console.log('this.warningFilter.time', this.warningFilter)
      })
    }

    this.resetWarning();
  }

  setWarningPage(page: number) {
    console.log('page', page, this.totalWarningPage)
    if (page <= this.totalWarningPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalWarningPage) {
        page = this.totalWarningPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.warningCurrentPage) {
        this.warningCurrentPage = page;
        this.getWarning();
      }
    } else {
      page = this.totalWarningPage;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_CANH_BAO'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputWarning').val(1);
        this.warningCurrentPage = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_CANH_BAO_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalWarningPage) {
          page = this.totalWarningPage;
        }
        $('#inputWarning').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.warningCurrentPage) {
          this.warningCurrentPage = page;
          this.getWarning();
        }
      }
    }
  }

  setWarningPageUseTime(page: number) {
    if (page <= this.totalWarningPageUseTime) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalWarningPageUseTime) {
        page = this.totalWarningPageUseTime;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPageUseTime) {
        this.currentPageUseTime = page;
        this.getWarningUseTime();
      }
    } else {
      page = this.totalWarningPageUseTime;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_CANH_BAO'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputPageUseTime').val(1);
        this.currentPageUseTime = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_CANH_BAO_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalWarningPageUseTime) {
          page = this.totalWarningPageUseTime;
        }
        $('#inputPageUseTime').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.currentPageUseTime) {
          this.currentPageUseTime = page;
          this.getWarningUseTime();
        }
      }
    }
  }

  setWarningPageRepeatTime(page: number) {
    if (page <= this.totalWarningPageRepeatTime) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalWarningPageRepeatTime) {
        page = this.totalWarningPageRepeatTime;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPageRepeatTime) {
        this.currentPageRepeatTime = page;
        this.getAlertRepeatTime();
      }
    } else {
      page = this.totalWarningPageRepeatTime;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_NHAC_NHO'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputPageRepeat').val(1);
        this.currentPageRepeatTime = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_CANH_BAO_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalWarningPageRepeatTime) {
          page = this.totalWarningPageRepeatTime;
        }
        $('#inputPageRepeat').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.currentPageRepeatTime) {
          this.currentPageRepeatTime = page;
          this.getAlertRepeatTime();
        }
      }
    }
  }

  goWarningPage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setWarningPage(toPage);
    }
  }

  goWarningPage2UseTime(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setWarningPageUseTime(toPage);
    }
  }

  goWarningPage2RepeatTime(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setWarningPageRepeatTime(toPage);
    }
  }

  filterWarning() {
    let data: any = {};

    if (this.isChongia) {
      data.type = 4;
    } else {
      data.type = 2;
    }
    if (this.warningFilter.serial) {
      data.serial = this.warningFilter.serial.trim();
    }
    if (this.productId4) {
      data.product_id = this.productId4;
    }
    let batch_id_value = $('#batch_id').val();
    if (batch_id_value) {
      data.batch_id = batch_id_value;
    }
    let batch_id1_value = $('#batch_id1').val();
    if (batch_id1_value) {
      data.batch_id = batch_id1_value;
    }
    let type_value = $('#type').val();
    if (type_value) {
      data.type = type_value;
    }
    let store_value = $('#store').val();
    if (store_value) {
      data.store_id = store_value;
    }
    let city_value = $('#city').val();
    if (city_value) {
      data.city = city_value;
    }
    let district_value = $('#district').val();
    if (district_value) {
      data.district = district_value;
    }
    if (this.warningFilter.time) {
      if (this.warningFilter.time.length > 0) {
        data.from = moment(this.warningFilter.time[0]).format('YYYY-MM-DD');
        data.to = moment(this.warningFilter.time[1]).format('YYYY-MM-DD');
      }
    }

    if (this.warningFilter.from) {
      data.active_from = moment(this.warningFilter.from[0]).format(
        'YYYY-MM-DD'
      );
      data.active_to = moment(this.warningFilter.from[1]).format('YYYY-MM-DD');
    }
    if (this.warningFilter.to) {
      data.dead_time_from = moment(this.warningFilter.to[0]).format(
        'YYYY-MM-DD'
      );
      data.dead_time_to = moment(this.warningFilter.to[1]).format('YYYY-MM-DD');
    }
    console.log('tuanbam', data)
    searchEvent(data, data, '', '')
    this.warningCurrentPage = 1;
    this.getWarning();
  }

  filterWarningUseTime() {
    this.currentPageUseTime = 1;
    this.getWarningUseTime();
  }

  filterAlertRepeatTime() {
    this.currentPageRepeatTime = 1;
    this.getAlertRepeatTime();
  }

  productId2: any = null;
  productId3: any = null;
  productId4: any = null;
  productId5: any = null;

  changeProduct2(event) {
    this.productId2 = event ? event : null;
  }

  changeProduct2Label(event) {
    $('.value span').text(event);
  }

  changeProduct3(event) {
    this.productId3 = event ? event : null;
  }

  changeProduct3Label(event) {
    $('.value span').text(event);
  }

  changeProduct4(event) {
    this.productId4 = event ? event : null;
  }

  changeProduct4Label(event) {
    $('.value span').text(event);
  }

  changeProduct5(event) {
    this.productId5 = event ? event : null;
  }

  changeProduct5Label(event) {
    $('.value span').text(event);
  }

  getWarning() {
    let data: any = {};
    data.offset =
      this.warningPage_Size *
      (this.warningCurrentPage <= 0 ? 0 : this.warningCurrentPage - 1);
    data.limit = this.warningPage_Size;


    if (this.isChongia) {
      data.type = 4;
    } else {
      data.type = 2;
    }
    if (this.warningFilter.serial) {
      data.serial = this.warningFilter.serial.trim();
    }
    // let product_value = $("#product").val();
    let product_value2 = this.productId2 ? this.productId2 : null;
    let product_value3 = this.productId3 ? this.productId3 : null;
    if (product_value2) {
      data.product_id = product_value2;
    }
    if (product_value3) {
      data.product_id = product_value3;
    }
    let batch_id_value = $('#batch_id').val();
    if (batch_id_value) {
      data.batch_id = batch_id_value;
    }
    // let product1_value = $("#product1").val();
    // if (product1_value) {
    //   data.product_id = product1_value;
    // }
    let batch_id1_value = $('#batch_id1').val();
    if (batch_id1_value) {
      data.batch_id = batch_id1_value;
    }
    let type_value = $('#type').val();
    if (type_value) {
      data.type = type_value;
    }
    let store_value = $('#store').val();
    if (store_value) {
      data.store_id = store_value;
    }
    let city_value = $('#city').val();
    if (city_value) {
      data.city = city_value;
    }
    let district_value = $('#district').val();
    if (district_value) {
      data.district = district_value;
    }
    if (this.warningFilter.time) {
      if (this.warningFilter.time.length > 0) {
        data.from = moment(this.warningFilter.time[0]).format('YYYY-MM-DD');
        data.to = moment(this.warningFilter.time[1]).format('YYYY-MM-DD');
      }
    }

    if (this.warningFilter.from) {
      data.active_from = moment(this.warningFilter.from[0]).format(
        'YYYY-MM-DD'
      );
      data.active_to = moment(this.warningFilter.from[1]).format('YYYY-MM-DD');
    }
    if (this.warningFilter.to) {
      data.dead_time_from = moment(this.warningFilter.to[0]).format(
        'YYYY-MM-DD'
      );
      data.dead_time_to = moment(this.warningFilter.to[1]).format('YYYY-MM-DD');
    }
    data.sort_scan_count = this.warningFilter.sort_scan_count
    data.sort_people_count = this.warningFilter.sort_people_count
    console.log('122222', data.sort_scan_count, data.sort_people_count, !data.sort_scan_count && !data.sort_people_count)
    if (!data.sort_scan_count && !data.sort_people_count) {
      data.sort_by = 'ins_dt:desc';
    }
    // if (this.warningFilter.city) {
    //   data.city = this.warningFilter.city;
    // }

    this.statisticService
      .getDashboardWarnings(data)
      .toPromise()
      .then((res) => {
        //console.log(res);
        if (!res.error) {
          this.warnings = res.data.data;
          let item = res.data.count;
          let pageString = (item / this.warningPage_Size).toString();
          let pageSplit = pageString.split('.');
          let last: any;
          let totalpage = parseInt(pageSplit[0]);
          if (pageSplit.length > 1) {
            last = pageSplit[1];
            if (parseInt(last) > 0) {
              totalpage++;
            }
          }
          this.totalWarningPage = totalpage;

          if (this.warnings.length > 0) {
            for (let i = 0; i < this.warnings.length; i++) {
              let serial: string = '';
              let number = this.warnings[i].number.toString();
              let pad = '000000';
              let serial_start = pad.substring(0, 6 - number.length) + number;
              if (this.warnings[i].product) {
                this.warnings[i].product.image = this.imageService.readSrcImage(
                  this.warnings[i].product.image,
                  'thumb_medium'
                );
              }
              this.warnings[i].serial =
                this.warnings[i].prefix + '-' + serial_start;
            }
          }
        }
      })
      .catch((err) => {
        this.toastr.error(err.message);
      });
  }

  getWarningUseTime() {
    let data: any = {};
    data.offset = this.warningPage_Size * (this.currentPageUseTime - 1);
    data.limit = this.warningPage_Size;
    data.sort_by = 'ins_dt:desc';

    if (this.isChongia) {
      data.type = 4;
    } else {
      data.type = 2;
    }
    if (this.warningFilter.serial) {
      data.serial = this.warningFilter.serial.trim();
    }

    if (this.productId4) {
      data.product_id = this.productId4;
    }

    // let product_value = $("#product").val();
    // if (product_value) {
    //   data.product_id = product_value;
    // }
    let batch_id_value = $('#batch_id').val();
    if (batch_id_value) {
      data.batch_id = batch_id_value;
    }
    // let product1_value = $("#product1").val();
    // if (product1_value) {
    //   data.product_id = product1_value;
    // }
    let batch_id1_value = $('#batch_id1').val();
    if (batch_id1_value) {
      data.batch_id = batch_id1_value;
    }
    let type_value = $('#type').val();
    if (type_value) {
      data.type = type_value;
    }
    let store_value = $('#store').val();
    if (store_value) {
      data.store_id = store_value;
    }
    let city_value = $('#city').val();
    if (city_value) {
      data.city = city_value;
    }
    let district_value = $('#district').val();
    if (district_value) {
      data.district = district_value;
    }
    if (this.warningFilter.time) {
      if (this.warningFilter.time.length > 0) {
        data.from = moment(this.warningFilter.time[0]).format('YYYY-MM-DD');
        data.to = moment(this.warningFilter.time[1]).format('YYYY-MM-DD');
      }
    }

    if (this.warningFilter.from) {
      data.active_from = moment(this.warningFilter.from[0]).format(
        'YYYY-MM-DD'
      );
      data.active_to = moment(this.warningFilter.from[1]).format('YYYY-MM-DD');
    }
    if (this.warningFilter.to) {
      data.dead_time_from = moment(this.warningFilter.to[0]).format(
        'YYYY-MM-DD'
      );
      data.dead_time_to = moment(this.warningFilter.to[1]).format('YYYY-MM-DD');
    }
    // if (this.warningFilter.city) {
    //   data.city = this.warningFilter.city;
    // }

    this.statisticService
      .getDashboardWarningUseTime(data)
      .toPromise()
      .then((res) => {
        if (!res.error) {
          this.warningsUseTime = res.data.logs || [];
          let item = res.data.total;
          let totalPage = Math.ceil(item / this.warningPage_Size);
          this.totalWarningPageUseTime = totalPage;
          console.log(this.totalWarningPageUseTime);

          // if (this.warnings.length > 0) {
          //   for (let i = 0; i < this.warnings.length; i++) {
          //     let serial: string = "";
          //     let number = this.warnings[i].number.toString();
          //     let pad = "000000";
          //     let serial_start = pad.substring(0, 6 - number.length) + number;
          //     if (this.warnings[i].product) {
          //       this.warnings[i].product.image = this.imageService.readSrcImage(
          //         this.warnings[i].product.image,
          //         "thumb_medium"
          //       );
          //     }
          //     this.warnings[i].serial =
          //       this.warnings[i].prefix + "-" + serial_start;
          //   }
          // }
        }
      })
      .catch((err) => {
        this.toastr.error(err.message);
      });
  }

  getAlertRepeatTime() {
    let opt: any = {};
    opt.offset = this.warningPage_Size * (this.currentPageRepeatTime - 1);
    opt.limit = this.warningPage_Size;
    let day_ago = $('#day-ago').val();
    if (day_ago) {
      opt.day_ago = day_ago;
    }
    if (this.productId5) {
      opt.product_id = this.productId5;
    }
    if (this.warningFilter.serial) {
      opt.serial = this.warningFilter.serial;
    }

    this.statisticService
      .getAlertRepeatTimeList(opt)
      .toPromise()
      .then((res) => {
        console.log('getAlertRepeatTime res:', res);
        if (res && !res.error && res.data) {
          let total = (res.data.total && res.data.total.total) || 0;
          let totalPage = Math.ceil(total / this.warningPage_Size);
          this.totalWarningPageRepeatTime = totalPage;
          
          if (res.data.list && Array.isArray(res.data.list)) {
            this.listAlertRepeatTime = res.data.list.map((item: any) => {
              let tmpItem = item;
              if (item.number !== undefined && item.number !== null) {
                let serialNumber = ('000000' + item.number.toString()).substring(
                  ('000000' + item.number.toString()).length - 6
                );
                item.serial = (tmpItem.prefix || '') + '-' + serialNumber;
              }
              return tmpItem;
            });
          } else {
            this.listAlertRepeatTime = [];
          }
        } else {
          this.listAlertRepeatTime = [];
          if (res && res.error) {
            console.error('getAlertRepeatTime error:', res.error);
          }
        }
      })
      .catch((err) => {
        console.error('getAlertRepeatTime catch:', err);
        this.listAlertRepeatTime = [];
      });
  }

  resetWarning() {
    this.warningFilter = {};
    this.productId2 = null;
    this.productId3 = null;
    this.productId4 = null;
    this.productId5 = null;
    this.warningCurrentPage = 1;
    this.currentPageUseTime = 1;
    this.currentPageRepeatTime = 1;
    $('.value span').text(this.translate.instant('SAN_PHAM'));
    $('.clear').hide();
    // $("#product").val(null).trigger("change");
    $('#batch_id').val(null).trigger('change');
    $('#day-ago').val(null).trigger('change');
    // $("#product1").val(null).trigger("change");
    $('#batch_id1').val(null).trigger('change');
    $('#type').val(null).trigger('change');
    $('#store').val(null).trigger('change');
    $('#city').val(null).trigger('change');
    $('#district').val(null).trigger('change');
    $('#outdate-serial').val(null).trigger('change');
    $('#outdate-product').val(null).trigger('change');
    $('#outdate_active_day').val(null).trigger('change');
    $('#outdate_dead_day').val(null).trigger('change');

    this.getWarning();
    this.getWarningUseTime();
    this.getAlertRepeatTime();
  }

  showReStore(item: any) {
    let detail = {
      name: item.batch.name,
      id: item.batch_id,
      id_start: item.number,
      id_end: item.number,
      prefix: item.prefix,
      readonly: true,
    };

    const initialState = { batch_detail: detail };
    this.modalRef = this.modalService.show(ModalCancelStampComponent, {
      initialState,
    });
    this.modalRef.content.closeBtnName = this.translate.instant('BO_QUA');
  }

  showLocation(warning, template) {
    if (warning.serial) {
      this.serialLocation = warning.serial;
      this.statisticService
        .getLocationSerialScan(warning.serial)
        .toPromise()
        .then((data) => {
          if (!data.error) {
            this.locationScan = data.data;
            if (this.locationScan.length > 0) {
              for (let i = 0; i < this.locationScan.length; i++) {
                this.locationScan[i].lat = parseFloat(this.locationScan[i].lat);
                this.locationScan[i].lon = parseFloat(this.locationScan[i].lon);
              }
              this.modalRefLocation = this.modalService.show(template);
            } else {
              this.toastr.warning(
                this.translate.instant('KHONG_CO_DU_LIEU_VI_TRI_QUET_CUA_SERIAL') + ' ' + warning.serial,
                '',
                {
                  timeOut: 3000,
                  positionClass: 'toast-bottom-right',
                }
              );
            }
          } else {
            this.toastr.error(data.error.message, '', {
              timeOut: 3000,
              positionClass: 'toast-bottom-right',
            });
          }
        })
        .catch((err) => {
          this.toastr.error(err.message, '', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        });
    }
  }

  viewDetail(data: any, page: number) {
    switch (page) {
      case 1: {
        this.router.navigate(['/evs/log-scan'], {
          queryParams: { response: 'warning', batch_id: data.id },
        });
        break;
      }
      case 2: {
        this.router.navigate(['/evs/guarantee/logs'], {
          queryParams: { status: 2, batch_id: data.id },
        });
        break;
      }
      case 3: {
        this.router.navigate(['/qrcode/distribution'], {
          queryParams: { batch_id: data.id },
        });
        break;
      }
      case 4: {
        this.router.navigate(['/qrcode/withdrawal'], {
          queryParams: { batch_id: data.id },
        });
        break;
      }
    }
  }

  viewCustomer(customer_name: any) {
    if (customer_name) {
      this.router.navigate(['/qrcode/customer/list'], {
        queryParams: { customer_name: customer_name },
      });
    } else {
      return;
    }
  }

  protected readonly JSON = JSON;
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/warning/warning/warning.component.ts